import { render, staticRenderFns } from "./page19.vue?vue&type=template&id=05b4290d&scoped=true&"
import script from "./page19.vue?vue&type=script&lang=js&"
export * from "./page19.vue?vue&type=script&lang=js&"
import style0 from "./page19.vue?vue&type=style&index=0&id=05b4290d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4290d",
  null
  
)

export default component.exports